/* eslint-disable no-unused-vars */
import { useState } from "react";

export type PaginationType = {
	offset: number;
	limit: number;
	changeOffset: (offset: number) => void;
	changeLimit: (limit: number) => void;
};

export default function usePagination() {
	const [offset, setOffset] = useState(0);

	const [limit, setLimit] = useState(10);

	function changeOffset(offsetParam: number) {
		setOffset(offsetParam);
	}
	function changeLimit(limitParam: number) {
		setLimit(limitParam);
	}

	return { offset, limit, changeOffset, changeLimit } as PaginationType;
}
